import { Box, Flex } from '@chakra-ui/react';
import React from 'react';

import HeroBanner from 'ui/home/HeroBanner';
import ChainIndicators from 'ui/home/indicators/ChainIndicators';
import LatestBlocks from 'ui/home/LatestBlocks';
import Stats from 'ui/home/Stats';
import Transactions from 'ui/home/Transactions';

const Home = () => {
  return (
    <Box as="main">
      <HeroBanner/>
      <Box
        mt={{ base: -4, lg: -16 }}
        _empty={{ mt: 0 }}
        position="relative"
        zIndex={ 2 }
        backgroundColor={{ _light: 'white', _dark: 'black' }}
        borderRadius="2xl"
        border="1px solid"
        borderColor={{ _light: 'gray.200', _dark: 'gray.800' }}
        boxShadow="sm"
        px={{ base: 3, lg: 4 }}
        py={{ base: 4, lg: 6 }}
      >
        <Flex
          flexDir={{ base: 'column', lg: 'row' }}
          columnGap={ 0 }
          rowGap={ 2 }
        >
          <Stats isHomePage={ true }/>
          <ChainIndicators/>
        </Flex>
      </Box>
      { /* <AdBanner mt={ 6 } mx="auto" display={{ base: 'flex', lg: 'none' }} justifyContent="center"/> */ }
      <Flex mt={ 8 } direction={{ base: 'column', lg: 'row' }} columnGap={ 4 } rowGap={ 6 }>
        <LatestBlocks/>
        <Box flexGrow={ 1 }>
          <Transactions/>
        </Box>
      </Flex>
    </Box>
  );
};

export default Home;
